export const FILE_UPLOADER_VALIDATION_WRONG_EXTENSION = 'File extension not allowed!';
export const FILE_GRID_INFO = 'Use one of these (Shift, Ctrl or Cmd) keys to multi-select';
export const FILE_MANAGER_REMOVE_WARNING = 'Are you sure you want to delete?';

export const getMaxFileSizeValidationMsg = (maxFileSize: number): string => 
  `Maximum file size to upload is ${maxFileSize}MB!`;

export const getFileLimitValidationMsg = (fileLimit: number): string => 
  `You can upload up to ${fileLimit} files at a time!`;
